export function LoadingWorld() {
  return <div className="loading-world" role="status"><div className="loading-orbit"><i /><i /><i /></div><p>ENTERING NEHALXAMAN</p><span>mapping our tiny universe…</span></div>;
}
